// extracted by mini-css-extract-plugin
export var container = "_q6-0";
export var dotAnimation = "_q6-2";
export var dotsLoading = "_q6-1";